import { useState, useEffect, useRef } from "react";

export default function LoanSlider({
  min = 50000,
  max,
  step = 5000,
  initial = 50000,
  onChange,
}) {
  const [amount, setAmount] = useState(initial);
  const rangeRef = useRef(null);

  useEffect(() => {
    if (onChange) {
      onChange(amount);
    }
  }, [amount, onChange]);

  const formatRupees = (value) => {
    return value.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    });
  };

  // Calculate the percentage of completion
  const getPercentage = () => {
    return ((amount - min) * 100) / (max - min);
  };

  return (
    <div className="bg-white p-3 rounded-xl w-full max-w-md text-center">
      <div className="relative">
        {/* Range input track background */}
        <div className="absolute w-full h-2 bg-gray-300 rounded-lg top-1/2 transform -translate-y-1/2"></div>

        {/* Completed strip */}
        <div
          className="absolute h-2 bg-green-700 rounded-lg top-1/2 transform -translate-y-1/2 "
          style={{ width: `${getPercentage()-1}%` }}
        ></div>

        {/* Input range slider */}
        <input
          ref={rangeRef}
          type="range"
          min={min}
          max={max}
          step={step}
          value={amount}
          onChange={(e) => setAmount(Number(e.target.value))}
          className="relative w-full h-2 bg-transparent appearance-none cursor-pointer accent-gray-300"
        />

        {/* Min and Max labels */}
        <div className="absolute w-full top-6 flex justify-between text-xs text-gray-600 px-1">
          <div className="flex flex-col items-start">
            <span>{formatRupees(min)}</span>
          </div>
          <div className="flex flex-col items-end">
            <span>{formatRupees(max)}</span>
          </div>
        </div>
      </div>

      {/* Display current amount */}
      <div className="mt-4 text-2xl font-bold text-green-700">
        {formatRupees(amount)}
      </div>
    </div>
  );
}
